import loadable from 'utils/loadable';

export default loadable(
  () => import('./ConfirmElectronicProviderSubmissionModal'),
  {
    fallback: <span />,
  }
);
